"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MODAL_PROJECT_ASSET_ITEM_CREATE = exports.MODAL_TYPE_PROJECT_ASSET_ITEM_CREATE = exports.COPY_PASTE_GROUP = exports.UNDO_REDO_GROUP = exports.SAVE_PROCESS_GROUP = exports.PluginId = void 0;
exports.PluginId = 'SOLUTION_EXPLORER';
exports.SAVE_PROCESS_GROUP = 'TOOLBAR.SAVE_PROCESS_GROUP';
exports.UNDO_REDO_GROUP = 'TOOLBAR.UNDO_REDO_GROUP';
exports.COPY_PASTE_GROUP = 'TOOLBAR.COPY_PASTE_GROUP';
exports.MODAL_TYPE_PROJECT_ASSET_ITEM_CREATE = 'SOLUTION_EXPLORER.PROJECT_ASSET_ITEM.CREATE';
exports.MODAL_PROJECT_ASSET_ITEM_CREATE = 'SOLUTION_EXPLORER.PROJECT_ASSET_ITEM.MODAL_CREATE';
//# sourceMappingURL=constants.js.map